import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class TasksComponent implements OnInit {

  constructor(public parent: ManagementComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.SearchInternalTasks(value);
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  SearchTerm:string;

  //search objects
  InternalTasks:any[];
  //for gallery objetcs
  Tasks:any[];

  Filter: {[k: string]: any} = {};
  Totals: any[];
  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  SeverityTypes:any[];
  InternalTaskStatuses:any[];
  InternalTaskEvents:any[];
  Periods:any[];
  Creators:any[];
  Assignees:any[];
  FilterLoading:boolean;
  Companies:{[k: string]: any} = [];
  CurrentTask:{[k: string]: any} = {};

  ShowFilter:boolean;

  ngOnInit(): void {
    this.InitializeFilter();
    this.GetInternalTasksMasterData();
    this.ShowFilter = false;
  }

  CloseOverlay(){
    this.InternalTasks = [];
    this.ShowFilter = false;
    this.SearchTerm = "";
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  InitializeFilter(){

    this.Companies.push(this.parent.Company);

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.Creator = {};
    this.Filter.Creator = null;

    this.Filter.Assignee = {};
    this.Filter.Assignee = null;

    this.Filter.Severity = {};
    this.Filter.Severity = null;

    this.Filter.TaskStatus = {};
    this.Filter.TaskStatus = null;    
  }

  SearchInternalTasks(searchTerm:string){
    if(searchTerm != null && searchTerm.length >= 2){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        SearchTerm:searchTerm,
        Filter:this.Filter
      };
    
     this.parent.loading = true;
    
     this.service.SearchInternalTasks(request).subscribe(response => {
    
       if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
       }
       else if(response["Status"] == 1){
         this.InternalTasks = response["InternalTasks"];
       }
    
       this.parent.loading = false;
      });    
    }
  }

  ViewTask(t:any){
  
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/newtask'], { queryParams: { id: t.ID } }));
    window.open(nextUrl, '_blank');
    // this.router.navigate(['/dashboard/sales/invoice'], { queryParams: { id: i.ID } }); 
  }

  GetInternalTasksMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.service.GetInternalTasksMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.SeverityTypes = response["SeverityTypes"];
     this.InternalTaskStatuses = response["InternalTaskStatuses"];
     this.InternalTaskEvents = response["InternalTaskEvents"];
     this.Periods = response["Periods"];
     
     this.GetInternalTasksFiltered();
    }
 
    this.parent.loading = false;
   });
   }

   GetAllInternalTasksCreators(){
    if(this.Creators == null || this.Creators.length == 0){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage()
      };
    
     this.FilterLoading = true;
    
     this.service.GetAllInternalTasksCreators(request).subscribe(response => {
    
       if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.Creators = response["Creators"];
       }
    
       this.FilterLoading = false;
      });
    }
   }

   GetAllInternalTasksAssignees(){
    if(this.Creators == null || this.Creators.length == 0){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage()
      };
    
     this.FilterLoading = true;
    
     this.service.GetAllInternalTasksAssignees(request).subscribe(response => {
    
       if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.Assignees = response["Assignees"];
       }
    
       this.FilterLoading = false;
      });
    }
   }

   GetInternalTasksFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.parent.loading = true;
    this.ShowFilter = false;

    this.service.GetInternalTasksFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Tasks = response["InternalTasks"];
        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
      
      this.GetInternalTasksFilteredCOUNT();
      this.parent.loading = false;
    });
  }

   GetInternalTasksFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }

    this.service.GetInternalTasksFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.ShowFilter = false;
      this.GetInternalTasksFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Company"){
      this.Filter.Company = null;
    }
    else if(filterType == "Creator"){
      this.Filter.Creator = null;
    }
    else if(filterType == "TaskSeverity"){
      this.Filter.Severity = null;
    }
    else if(filterType == "Status"){
      this.Filter.TaskStatus = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Assignee"){
      this.Filter.Assignee = null;
    }

    this.GetInternalTasksFiltered();
  }

  DeleteInternalTask(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      TaskID:this.CurrentTask.ID,
    };
  
    this.parent.loading = true;
  
    this.service.DeleteInternalTask(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       this.Tasks = this.Tasks.filter(x => x.ID != this.CurrentTask.ID);
       this.ShowDeleteTaskContainer = false;
      }
  
      this.CurrentTask = null;
      this.parent.loading = false;
    });
  
  }

  ShowDeleteTaskContainer:boolean;

}
